import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesDisponibles() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Disponible", items: [
      { label: "Disponible", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponible", desc: "Inventario disponible", enabled: !!user.menu_disponible },
      { label: "Disponible Vendedor", icon: "fas fa-tasks", color: "#10b981", href: "/ListadoDisponibleVendedor", desc: "Disponible por vendedor", enabled: !!user.disponible_vendedores },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Disponibles"
      descripcion="Consulta de inventario disponible"
      icono="fas fa-tasks"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesDisponibles;
